export const customImageLoader = ({ src, width, quality }) => {
	return `${src}?w=${width}&q=${quality || 50}`;
};

// const customLoader = ({ src, width, quality }) => {
// 	return `${src}?w=${width}&q=${quality || 75}`;
// };

// export default customLoader;
